import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  input,
  Input,
  Output,
} from '@angular/core';
import { AsyncPipe, CommonModule, NgIf } from '@angular/common';
import { TranslatePipe } from '@core/pipes';

@Component({
  selector: 'sc-section',
  imports: [AsyncPipe, TranslatePipe, NgIf, CommonModule],
  templateUrl: './section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionComponent {
  public isDisabled = input<boolean>(false);
  @Input()
  title = '';

  @Input()
  subTitle = '';

  @Output()
  infoLinkClick = new EventEmitter();
}
